export const IG = {
    translations: {
        notifications: 'Ngosi',
        markAllAsRead: 'kaa ihe niile ka agụlaha',
        poweredBy: 'kwadoro site na',
        settings: 'Mwube gasị',
        noNewNotification: 'Ọnweghị ihe ọhụrụ ịhụ ebe a',
    },
    lang: 'ig',
};
